import { client } from "../../../infrastructure/graphql/client";
import {
  GET_VM_COST_ANALYSIS,
  GET_ALL_VM_COST_ANALYSES,
  ANALYZE_ALL_VM_COSTS,
} from "../../../infrastructure/graphql/aiQueries/vmCostAnalysisQueries";

export class VmCostAnalysisService {
  async getVmCostAnalysis(vmId) {
    try {
      const result = await client.query({
        query: GET_VM_COST_ANALYSIS,
        variables: { vmId },
        fetchPolicy: "network-only",
      });

      const response = result.data?.getVmCostAnalysis;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get VM cost analysis error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }

  async getAllVmCostAnalyses() {
    try {
      const result = await client.query({
        query: GET_ALL_VM_COST_ANALYSES,
        fetchPolicy: "network-only",
      });

      const response = result.data?.getAllVmCostAnalyses;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get all VM cost analyses error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }

  async analyzeAllVmCosts() {
    try {
      const result = await client.mutate({
        mutation: ANALYZE_ALL_VM_COSTS,
      });

      const response = result.data?.analyzeAllVmCosts;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Analyze all VM costs error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }
}